<style lang="scss" scoped>
  .list-group {
    margin-bottom: 0;
  }
</style>

<template>
  <div class="automation-rules-component">
    <div class="row m-b-10">
      <div class="col-md-3">
        <h4>{{ __('Regras da campanha') }}</h4>
      </div>
      <div class="col-md-9">
        <a
          class="btn btn-box float-right"
          href="javascript:;"
          @click="openModal()"
        ><i class="fa fa-plus" /> {{ __('Adicionar Regra') }}</a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <label>{{ __('Regras de entrada') }}</label>
        <select
          class="form-control"
          name="type"
          v-model="type"
        >
          <option
            v-for="current in types"
            :key="current.value"
            :value="current.value"
          >
            {{ __(current.name) }}
          </option>
        </select>
      </div>
      <div class="col-md-12 m-t-10">
        <span v-if="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
        <ul
          class="list-group"
          v-else
        >
          <li
            class="list-group-item justify-content-start"
            v-for="rule in rules"
            :key="rule.name"
          >
            {{ __(rule.name) }}<span v-if="rule.automatable"><i class="fa fa-angle-right mx-1" /><strong>{{ __(rule.automatable.name) }}</strong></span><span v-if="!rule.automatable && rule.value"><i class="fa fa-angle-right mx-1" /><strong>{{ rule.value }}</strong></span><span class="ml-auto"><a
              href="javascript:void(0);"
              @click="removeRule(rule)"
            > Excluir</a></span>
          </li>
        </ul>
      </div>
    </div>
    <BModal
      id="add-rule-modal"
      ref="add-rule-modal"
      hide-footer="hide-footer"
      modal-class="modal-width-400"
    >
      <template slot="modal-title">
        {{ __('Adicionar Regra') }}
      </template>
      <template slot="default">
        <form
          method="post"
          @submit.prevent="addRule()"
        >
          <div class="form-group">
            <label>{{ __('Regra') }}</label>
            <select
              class="form-control"
              name="rule_types"
              v-model="rule.type"
            >
              <option value="">
                {{ __('Selecione') }}
              </option>
              <option
                v-for="(current, index) in rule_types"
                :key="index"
                :value="index"
              >
                {{ __(current.name) }}
              </option>
            </select>
          </div>
          <div
            class="form-group"
            v-show="rule.type && rule.has_options"
          >
            <label v-text="getValueInputPlaceholder(rule)" />
            <select
              class="form-control"
              v-model="rule.value"
              v-if="rule_values.length"
            >
              <option
                v-for="current in rule_values"
                :key="current.value"
                :value="current.value"
              >
                {{ __(current.text) }}
              </option>
            </select>
            <input
              class="form-control"
              :type="getValueInputType(rule)"
              :placeholder="getValueInputPlaceholder(rule)"
              v-model="rule.value"
              v-else
            >
          </div>
          <div
            class="form-group"
            v-if="rule.option_input"
            v-show="rule.type"
          >
            <label v-text="rule.option_input.placeholder" />
            <input
              class="form-control"
              :type="rule.option_input.type"
              :placeholder="rule.option_input.placeholder"
              v-model="rule.option"
            >
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-box"
              type="submit"
              @click.prevent="addRule()"
              :disabled="disabled"
            >
              <span v-if="!saving">{{ __('Salvar') }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Salvando') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';
import { Alert } from '../../services/alert';

export default {
  components: {
    BModal,
  },

  mounted () {
    this.loadRules();
  },

  props: ['user', 'value', 'available'],

  data () {
    return {
      automation: this.value,
      type: this.value.type,
      types: [
        { name: this.__('Todas as regras devem ser respeitadas'), value: 'all' },
        { name: this.__('Apenas uma das regras precisa ser respeitada'), value: 'any' },
      ],
      rules: [],
      rule_types: this.available,
      rule_values: [],
      rule: {
        type: '',
        value: '',
        value_input: {},
        has_options: false,
        option: null,
        option_input: false,
      },
      loading: true,
      saving: false,
    };
  },

  watch: {
    'type': function () {
      this.updateAutomation();
    },

    'rule.type': function (type) {
      if (type) {
        this.loadRuleTypeValues(type);
      }
    },
  },

  computed: {
    disabled () {
      return this.saving || this.rule.type == null;
    },
  },

  methods: {
    loadRules () {
      this.$http.get(`/automation/${this.automation.id}/rule`)
        .then((response) => {
          this.rules = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadRuleTypeValues (type) {
      this.$http.get(`/automation/rule/value?type=${type}`)
        .then((response) => {
          const rule = response.data;

          console.log(rule);

          this.rule_values = [];
          this.rule.value = '';
          this.rule.has_options = rule.options || false;
          this.rule.value_input = rule.value_input || {};
          this.rule.option = null;
          this.rule.option_input = rule.option_input || false;

          if (rule.values.length) {
            this.rule_values = rule.values;
            this.rule.value = rule.values[0].value;
          }

          // console.log(this.rule);
          // console.log(this.rule_values);
        })
        .catch(() => {
          this.rule_values = [];
          this.rule.value = '';
          this.rule.has_options = false;

          Alert.error(this.__('Nenhuma opção encontrada.'));
        });
    },

    openModal () {
      this.$refs['add-rule-modal'].show();
    },

    getValueInputType (rule) {
      if (rule.value_input && rule.value_input.type) {
        return rule.value_input.type;
      }

      return 'text';
    },

    getValueInputPlaceholder (rule) {
      if (rule.value_input && rule.value_input.placeholder) {
        return rule.value_input.placeholder;
      }

      return this.__('Opção / Valor');
    },

    updateAutomation () {
      if (this.type === this.automation.type) {
        return;
      }

      this.automation.type = this.type;
      this.$emit('input', this.automation);

      this.$http.put(`/automation/${this.automation.id}`, { type: this.type });
    },

    addRule () {
      this.saving = true;

      const data = {
        type: this.rule.type,
        value: this.rule.value,
        option: this.rule.option,
      };

      this.$http.post(`/automation/${this.automation.id}/rule`, data)
        .then(() => {
          this.reset();
          this.loadRules();

          this.$refs['add-rule-modal'].hide();
        }).finally(() => {
          this.saving = false;
        });
    },

    reset () {
      this.rule.type = '';
      this.rule.value = '';
      this.rule.has_options = false;
      this.rule.input = {};
    },

    async removeRule (rule) {
      if (! await Confirm(this.__('Deseja excluir a regra?'))) {
        return;
      }

      this.$http.delete(`/automation/${this.automation.id}/rule/${rule.id}`)
        .then(() => {
          this.rules.splice(this.rules.indexOf(rule), 1);
        })
        .catch((response) => {
          Alert.error(response.message);
        });
    },
  },
};
</script>
